<div class="page-layout carded left-sidenav toolbar-fixed-layout">

  <mat-sidenav-container>

    <!-- CENTER -->
    <div class="center">

      <!-- CONTENT CARD -->
      <div class="content-card mat-white-bg">
        <mat-tab-group class="toolbar-in-the-tab" [selectedIndex]="currentTabIndex"
                       (selectedIndexChange)="onTabChange($event)">
          <mat-tab *ngFor="let tab of tabs; let i = index" label="{{tab.title}}">
            <div class="toolbar second-level-toolbar toolbar-disabled flex flex-row justify-between items-center">

              <div class="grid-toolbar-buttons-group-container flex flex-col justify-center items-start">
                <label class="component-label"> Actions</label>
                <div class="grid-toolbar-buttons-group flex flex-row justify-start items-center">
                  <div class="button-container flex flex-row justify-start items-center">
                    <button [disabled]="tab.id !== 1"
                            (click)="onClickAddNotification()"
                            mat-button class="orbitax-flat-button add-notification"
                            particleAnalytics
                            analyticsCategory="notification-content"
                            analyticsAction="add notification"
                    >Add Notification
                    </button>

                    <div class="toolbar-separator"></div>
                  </div>

                  <div class="button-container flex flex-row justify-start items-center">
                    <button [disabled]="currentSelectedRows.length === 0 || tab.id !== 1"
                            (click)="onClickDelete()"
                            mat-button class="orbitax-flat-button"
                            particleAnalytics
                            analyticsCategory="notification-content"
                            analyticsAction="delete">Delete
                    </button>
                    <div class="toolbar-separator"></div>
                  </div>

                </div>
              </div>

            </div>

            <div class="content pos-relative m-t-30 m-b-30 m-l-30 m-r-30">


              <div class="keno-grid-container">
                <particle-smart-grid *ngIf="currentTabIndex === i"
                                     [sourceType]="sourceType"
                                     [selectableSettings]="selectableSettings"
                                     (selectionChanged)="onSelectionChanged($event)">
                </particle-smart-grid>
              </div>

            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  </mat-sidenav-container>
</div>
